import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import ForgotPasswordForm from '@/app/sign-in/ForgotPasswordForm';
import SignInPanel from '@/app/sign-in/SignInPanel';
import { FullPage } from '@/components/page';
import { Link, Text } from '@/components/typography';
import { ROUTES } from '@/router';

const ForgotPassword = () => {
  return (
    <FullPage title={t`Reset Password`}>
      <SignInPanel
        title={t`Reset your password`}
        description={<Trans>We can email you a one-time password reset link.</Trans>}
        footer={
          <>
            <Text variant="caption1" color="grey">
              <Trans>
                Don't want to reset your password?{' '}
                <Link variant="caption1" color="aqua" to={ROUTES.signInPassword.path}>
                  {t`Sign in with password`}
                </Link>
              </Trans>
            </Text>
            <Text variant="caption1" color="grey">
              <Trans>
                Prefer to not use a password?{' '}
                <Link variant="caption1" color="aqua" to={ROUTES.signIn.path}>
                  {t`Sign in another way`}
                </Link>
              </Trans>
            </Text>
          </>
        }
      >
        <ForgotPasswordForm />
      </SignInPanel>
    </FullPage>
  );
};

export default ForgotPassword;
